import { render, staticRenderFns } from "./BaseG3List.vue?vue&type=template&id=49f4f384&scoped=true"
import script from "./BaseG3List.vue?vue&type=script&lang=js"
export * from "./BaseG3List.vue?vue&type=script&lang=js"
import style0 from "./BaseG3List.vue?vue&type=style&index=0&id=49f4f384&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f4f384",
  null
  
)

export default component.exports